import type { AssetAllocation } from 'types/pools'

export const sortByAssetAllocation = (assetAllocation: AssetAllocation[], vaultAddress?: string) => {
  const normalizedVaultAddress = vaultAddress?.toLowerCase()

  return assetAllocation
    .filter((asset) => asset.asset.toLowerCase() !== normalizedVaultAddress)
    .sort((a, b) => b.allocation - a.allocation)
}
